/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SearchFiltersSchemaFundingFilterType = typeof SearchFiltersSchemaFundingFilterType[keyof typeof SearchFiltersSchemaFundingFilterType];


export const SearchFiltersSchemaFundingFilterType = {
  c: 'c',
  p: 'p',
  cp: 'cp',
} as const;
